import { render, staticRenderFns } from "./sell-report.vue?vue&type=template&id=8b07510e&"
import script from "./sell-report.vue?vue&type=script&lang=js&"
export * from "./sell-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports